import React, { useEffect } from 'react'
import MemberList from '../components/MemberList'
import { Link } from 'react-router-dom'

export default function Members() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Members</h1>
        <Link to="/new-member"><button className="memberAddButton">Create New</button></Link>
      </div>
        <MemberList />
    </div>
  )
}
